<template>
  <div class="index">
    <nav class="nav has-shadow">
      <div class="container">
        <div class="nav">
        </div>
        <div class="nav-right">
          <a class="nav-item is-tab" @click="logout">Выход</a>
        </div>
      </div>
    </nav>
    <aside class="menu is-flex">
      <ul class="menu-list">
        <router-link v-for="item in userMenu" :to="{ name: item.name }" :key="item.name" active-class="is-active" class="nav-item is-tab">{{item.title}}</router-link>
      </ul>
      <div class="menu-list link">
        <a class="nav-item" :href="docAdminLink">Ссылка на новую административную панель</a>
      </div>
    </aside>
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      userMenu: [],
      docAdminLink: '/doc-admin/ru/tenant/grottsite/files'
    }
  },
  name: 'Index',
  methods: {
    ...mapActions(['logout']),
    buildDocAdminLink () {
      const { protocol, hostname, port } = window.location
      const targetHostname = hostname.startsWith('admin.')
        ? hostname.slice('admin.'.length)
        : hostname
      const portSegment = port ? `:${port}` : ''
      return `${protocol}//${targetHostname}${portSegment}/doc-admin/ru/tenant/grottsite/files`
    }
  },
  computed: {
    ...mapState(['menu', 'user'])
  },
  created () {
    this.userMenu = this.menu.main.filter(i => i.roles.includes(this.user.role))
    this.docAdminLink = this.buildDocAdminLink()
  }
}
</script>

<style scoped>
.menu {
  max-width: 242px;
  float: left;
  flex-direction: column;
}
.menu a.is-active {
  background: transparent
}
.container {
  width: 100% !important;
}
.main-content {
  margin-top: 5px;
  float: left;
  width: calc(100% - 250px)
}
.link {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?30c60d7a